import axios from '@/libs/api.request'

/**
 * 查询周转物
 */
export const queryTurnoverBoxList = (data) => {
	return axios.request({
		url: '/api/v1/turnoverBox/queryTurnoverBoxList',
		params: data,
		method: 'get'
	})
};

/**
 * 查询关联周转物
 */
export const querySortingTurnoverBoxList = (data) => {
	return axios.request({
		url: '/api/v1/turnoverBox/querySortingTurnoverBoxList',
		params: data,
		method: 'get'
	})
};

/**
 * 创建称重框
 */
export const createTurnover = (data) => {
	return axios.request({
		url: '/api/v1/turnoverBox/createTurnover',
		data,
		method: 'post'
	})
};

/**
 * 保存周转物设置
 */
export const saveBoxSetting = (data) => {
	return axios.request({
		url: '/api/v1/turnoverBox/saveBoxSetting',
		data,
		method: 'post'
	})
};

/**
 * 更新商品周转物
 */
export const updateSortingTurnoverBox = (data) => {
	return axios.request({
		url: '/api/v1/turnoverBox/updateSortingTurnoverBox',
		data,
		method: 'post'
	})
};

/**
 * 更新订单周转物
 */
export const updateOrderTurnoverBox = (data) => {
	return axios.request({
		url: '/api/v1/turnoverBox/updateOrderTurnoverBox',
		data,
		method: 'post'
	})
};



// WEBPACK FOOTER //
// ./src/api/sorting/turnoverBox.js